<template>
  <div v-if="ready" class="details">
    <AppHeader :title="feature.name" :items="menu" :backButton="{
      container: 'app',
      page: 'Features'
    }" />
    <v-container class="pl-3 pr-3 pb-3" fluid grid-list-xl>
      <Informations v-if="$route.params.type === 'informations'" :feature="feature" />
    </v-container>
  </div>
</template>

<script>
import AppHeader from '@/components/ui/AppHeader.vue'
import Informations from './components/details/Informations.vue'
import { getFeature } from '@/services/containers/app/features'

export default {
  name: 'Details',
  components: {
    AppHeader,
    Informations
  },
  data: () => ({
    feature: {},
    menu: [
      {
        title: 'Informações',
        value: 'informations',
        icon: 'dashboard',
        show: () => true
      },
    ],
    ready: false
  }),
  async created() {
    await this.fetchFeature()
  },
  methods: {
    async fetchFeature() {
      this.$showLoading()
      try {
        const { id } = this.$route.params
        const { data } = await getFeature(id)
        this.feature = data
        this.ready = true
      } catch (error) {
        this.$hideLoading()
        this.ready = true
        this.$toast(error.response.data.message, 'red')
      } finally {
        this.$hideLoading()
      }
    }
  }
}

</script>